
<template>
  <ion-button
    slot="icon-only"
    size="large"
    :router-link="linkTo"
    :disabled="disabled"
    class="nav-button"
    :class="{ 'is-active': active }"
    @click="$emit('click')"
  >
    <ion-icon
      :icon="icon"
      :color="active ? 'primary' : 'secondary'"
      size="large"
      class="ion-padding"
    />
  </ion-button>
</template>

<script>
import { IonButton, IonIcon } from '@ionic/vue';

export default {
    components: {
        IonButton,
        IonIcon,
    },
    props: {
        linkTo: {
            type: String,
            required: false,
            default: ''
        },
        icon: {
            type: String,
            required: false,
            default: ''
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        active: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: ['click'],
};
</script>

<style scoped>
ion-icon {
  padding: 5px;
}

ion-button {
  border: 2px solid var(--ion-color-secondary);
  border-radius: 6px;
}

/* Eigener Hintergrund, da das Theme clear-Buttons in ion-content transparent macht (MenuLeft).
   Muss vor .is-active stehen, damit der aktive Zustand gewinnt. */
ion-button.nav-button {
  --background: var(--ion-color-primary);
}

ion-button.is-active {
  --background: var(--ion-color-secondary);
  --background-activated: var(--ion-color-secondary);
  --background-focused: var(--ion-color-secondary);
  --background-hover: var(--ion-color-secondary-shade);
  --border-color: var(--ion-color-primary);
}
</style>
